module.exports = __webpack_public_path__ + "03_short_brown.8bddbf68.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/03_short_brown.png
// module id = 7TWm
// module chunks = 0